<template>
  <component :is="baseComponent" :to="link.path ? link.path : '/'" class="menu-li" :class="{active: isActive}" tag="li">
    <a v-if="isMenu" data-toggle="collapse" href="javascript:void(0)" @click="collapseMenu">
      <i :class="link.icon"></i>
      <p>{{link.name}}
        <b class="caret"></b>
      </p>
    </a>
    <div v-if="$slots.default || this.isMenu">
      <el-collapse-transition>
        <ul class="nav mt-2 ml-2" v-show="!collapsed">
          <slot></slot>
        </ul>
      </el-collapse-transition>
    </div>
    <slot name="title" v-if="children.length === 0 && !$slots.default && link.path">
      <a target="_blank" :href="link.path" v-if="link.target">
        <a target="_blank" :href="$rootUrl + '/Guia.pdf'" class="guia" v-if="link.target" style="line-height: 30px;">
          <span class="themifyIcon">
            <i :class="link.icon"></i>
          </span>
          <p>{{link.name}}</p>
        </a>
      </a>
      <component :to="link.path" :is="elementType(link, false)" :target="link.target" :href="link.path" v-else>
        <template v-if="addLink">
          <span class="sidebar-mini ">
            <i :class="link.icon"></i>
          </span>
          <span class="sidebar-normal">{{link.name}}</span>
        </template>
        <template v-else>
          <i :class="link.icon"></i>
          <p>{{link.name}}</p>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  import {
    FontAwesomeIcon
  } from '@fortawesome/vue-fontawesome'
  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition,
      FontAwesomeIcon
    },
    props: {
      menu: {
        type: Boolean,
        default: false
      },
      link: {
        type: Object,
        default: () => {
          return {
            name: '',
            path: '',
            children: []
          }
        }
      }
    },
    provide() {
      return {
        addLink: this.addChild,
        removeLink: this.removeChild
      }
    },
    inject: {
      addLink: {
        default: null
      },
      removeLink: {
        default: null
      }
    },
    data() {
      return {
        children: [],
        collapsed: false
      }
    },
    computed: {
      baseComponent() {
        return this.isMenu || this.link.isRoute ? 'li' : 'router-link'
      },
      isMenu() {
        return this.children.length > 0 || this.menu === true
      },
      isActive() {
        if (this.$route) {
          let matchingRoute = this.children
            .find((c) => this.$route.path.startsWith(c.link.path))
          if (matchingRoute !== undefined) {
            return true
          }
        }
        return false
      }
    },
    methods: {
      addChild(item) {
        const index = this.$slots.default.indexOf(item.$vnode)
        this.children.splice(index, 0, item)
      },
      removeChild(item) {
        const tabs = this.children
        const index = tabs.indexOf(item)
        tabs.splice(index, 1)
      },
      elementType(link, isParent = true) {
        if (link.isRoute === false) {
          return isParent ? 'li' : 'a'
        } else {
          return 'router-link'
        }
      },
      linkAbbreviation(name) {
        const matches = name.match(/\b(\w)/g)
        return matches.join('')
      },
      collapseMenu() {
        this.collapsed = !this.collapsed
      },
      collapseSubMenu(link) {
        link.collapsed = !link.collapsed
      }
    },
    mounted() {
      if (this.addLink) {
        this.addLink(this)
      }
      if (this.link.collapsed !== undefined) {
        this.collapsed = this.link.collapsed
      }
      if (this.isActive && this.isMenu) {
        this.collapsed = false
      }
    },
    destroyed() {
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el)
      }
      if (this.removeLink) {
        this.removeLink(this)
      }
    }
  }

</script>
<style>
  /*   .sidebar .sidebar-wrapper>.nav p,
  .off-canvas-sidebar .sidebar-wrapper>.nav p {
    display: inline-block;
    line-height: 30px;
  }

  .svg-inline--fa {
    margin-right: 15px;
    line-height: 30px;
    width: 30px;
    height: 30px;
  } */
  .menu-li {
    display: inline-block;
    width: 100%;
  }

  .guia {
    color: #737373 !important;
  }

  .themifyIcon {
    font-size: 24px;
    float: left;
    margin-right: 15px;
    line-height: 30px;
    width: 30px;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SidebarItem.vue